import { Typography } from 'antd';

import { StyledModal } from 'common/components';

import { WizardHierarchyModal } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardHierarchyModal';

export const WizardHierarchyAction = ({
  productId,
  productName,
  uniqueId,
  visible,
  onClose,
}) => {
  return (
    <StyledModal
      title={
        <>
          <Typography.Text>Hierarchies for product </Typography.Text>
          <Typography.Link href={`/product/${productId}`} target='_blank'>
            {productName}
          </Typography.Link>
        </>
      }
      visible={visible}
      onCancel={onClose}
      bodyStyle={{ minHeight: 400, maxHeight: 600, paddingTop: 4 }}
      width={1200}
      closable
      maskClosable={false}
      destroyOnClose={false}
      zIndex={1020}
      footer={null}
    >
      <WizardHierarchyModal
        productId={productId}
        uniqueId={uniqueId}
        offModalListHierarchy={onClose}
      />
    </StyledModal>
  );
};
